import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 25px;
  background: #2a2a2a;

  color: #000;

  a {
    color: #000;

    &:hover {
      text-decoration: none;
    }
  }
`;

const Inner = styled.div`
  border: solid 1px #989898;
  padding: 40px 80px;
  background: #eaeaea;
`;

const Logo = styled.div`
  color: #000;
  font-size: 24px;
  font-weight: bold;
  margin: 0 0 20px 0;
`;

interface Props {}

const HomeView = ({}: Props) => (
  <Wrapper>
    <Inner>
      <Logo>NBW apps</Logo>
      <p>Contact Us:</p>
      <a href="mailto:nbwapps@gmail.com">nbwapps@gmail.com</a>
    </Inner>
  </Wrapper>
);

export default HomeView;
